const dataUpdatable = {
  methods: {
    updateData(data) {
      Object.entries(data).forEach(([dataKey, dataValue]) => {
        this[dataKey] = dataValue;
      });
    },
  },
};

export default dataUpdatable;
